import { useMultipleFeatureFlags } from '@agentnet/feature-flags';
import React from 'react';
import LoadingSpinner from 'ui-kit/components/LoadingSpinner';
import { FeatureFlag } from 'utilities/constants/launch-darkly-flags';
import Billing from './Billing';
import PaymentMethod from './PaymentMethod';
import ContentContainer from 'ui-kit/components/utility/ContentContainer';

const BillingMethods = () => {
  const [autopay] = useMultipleFeatureFlags(FeatureFlag.SHOW_AUTOPAY);

  // Wait for the flag to resolve before choosing a page, otherwise Billing
  // mounts during the loading window and fires its own epay-accounts request.
  if (!autopay.ready) {
    return (
      <ContentContainer mTop="150px">
        <LoadingSpinner variant="circle" status="pending" />
      </ContentContainer>
    );
  }

  if (autopay.value) {
    return <PaymentMethod />;
  }

  return <Billing />;
};

export default BillingMethods;
